module.exports = __webpack_public_path__ + "common/logistics/icon-citylink-50aa6b07866ea54012a1339ff53be528.svg";